import { homeComponent } from './home.component';

export const homeStateName = 'app.home';

export const homeState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: homeStateName,
    url: '/',
    component: homeComponent.name,
    data: { requiresAuth: true },
    resolve: {
      maybeRedirect: ($state, userService, appConfig, $window, envService) => {
        if (userService.isAdmin()) {
          $state.go('app.admin');
          return true;
        }

        if (userService.isDwsOnly()) {
          $state.go('app.receiving.list', { product: 'DWS' });
          return true;
        }

        const { ui } = appConfig;
        if (ui.v2UI.oldBank && ui.v2UI.newBank && !envService.isLocalhost()) {
          $window.location.href = '/v2/';
        }
        return false;
      },
    },
  });
};
